import { useUpdateAccountMutation, type Locale } from 'generated/gql';
import { useLingui } from '@lingui/react';
import { localeToIso } from 'helpers/locale';
import { useAccount } from 'hooks/useAccount';
import { useCallback } from 'react';

export const useSetLocale = () => {
  const { i18n } = useLingui();
  const account = useAccount();
  const [setAccount] = useUpdateAccountMutation();

  return useCallback(
    (locale: Locale) => {
      // Only update language setting for current user if user is logged in.
      if (account) {
        setAccount({
          variables: {
            account: {
              locale,
            },
          },
          onCompleted: () => {
            i18n.activate(localeToIso(locale));
          },
        });
      }
    },
    [i18n, setAccount, account],
  );
};
